import { Localized, useLocalization } from '@fluent/react';
import { Textarea } from '@vechaiui/react';
import { useField } from 'formik';

import { CancellationRemarkComboboxFormik } from '#/components/controls/CancellationRemarkCombobox';
import { InputFormik } from '#/components/controls/Input';
import { ProfileType } from '#/hooks';

const OrderCancellationForm: React.FC<OrderCancellationFormProps> = ({ name, userType }) => {
  const namePrefix = name ? `${name}.` : '';
  const { l10n } = useLocalization();
  const [selection] = useField(`${namePrefix}selection`);

  return (
    <div className="space-y-5">
      <Localized id="reason" attrs={{ placeholder: true }}>
        <CancellationRemarkComboboxFormik
          label={l10n.getString('select-reason')}
          name={`${namePrefix}selection`}
          userType={userType}
        />
      </Localized>
      {selection.value === '99' && (
        <Localized id="other-reason" attrs={{ placeholder: true }}>
          <InputFormik
            as={Textarea}
            label={l10n.getString('other-reason')}
            name={`${namePrefix}remark`}
            type="text"
          />
        </Localized>
      )}
    </div>
  );
};
export type OrderCancellationFormProps = {
  name?: string;
  userType: ProfileType;
};

export default OrderCancellationForm;
